'use client'
import React, { useState } from 'react';
import VideoModal from '@/components/wise/VideoModal'

const HeroBanner = () => {
  const [open, setOpen] = useState(false)
  const [videoUrl, setVideoUrl] = useState('')

  const openVideo = (url) => {
    setVideoUrl(url)
    setOpen(true)
  }

  const closeVideo = () => {
    setOpen(false)
    setVideoUrl('')
  }

  return (
    <section className="hero-banner-wise wise-bg-blue-gradient mob-padding">
      <div className="container-fluid">
        <div className="msu-wise-banner">
          {/* Slide 1 */}
          <div className="msu-wise-slide">
            <div className="row align-items-center">
              <div className="col-md-6 mb-4 mb-md-0">
                <h1 className="wise-banner-title">
                  Partner With Us to Transform{' '}
                  <span className="highlight-text">
                    Education, Skills & Employability
                  </span>{' '}
                  at Scale
                </h1>
                <p className="wise-banner-desc text-white px-4">
                  Co-create and deliver outcome-driven higher education and skilling programs through strong industry–academia collaboration
                </p>
                <a href="/partner-registration" className="me-2 wise-banner-btn mt-4">
                  Become a Partner
                </a>
              </div>
              <div className="col-md-6 mob-d-none">
                <div className="banner-thumbnail-wrapper d-flex justify-content-center align-items-center">
                  <div className="banner-thumbnail position-relative">
                    <img
                      className="video-bg"
                      src="/wise-lp/images/banner-thumbnail.png"
                      alt="Video Thumbnail"
                    />
                    <button
                      onClick={() => openVideo('https://www.youtube.com/watch?v=Cb7SL53UlPo')}
                      className="play-button"
                    >
                      <img
                        className="play-btn"
                        src="https://cdn.msu.edu.in/landing-page-images/play-button.svg"
                        alt="Play Icon"
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Modal for video */}
      {/* {showModal && (
        <div className="video-modal" style={{ position: 'fixed', top: '0', left: '0', right: '0', bottom: '0', backgroundColor: 'rgba(0, 0, 0, 0.7)', zIndex: '1000' }}>
          <div style={{ position: 'relative', margin: 'auto', padding: '20px', top: '50%', transform: 'translateY(-50%)', maxWidth: '80%' }}>
            <div style={{ textAlign: 'right' }}>
              <button onClick={handleCloseModal} style={{ background: 'none', border: 'none', color: 'white', fontSize: '30px' }}>×</button>
            </div>
            <iframe
              width="100%"
              height="500"
              src={videoUrl}
              title="Video"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          </div>
        </div>
      )} */}
      <VideoModal open={open} videoUrl={videoUrl} onClose={closeVideo} />
    </section>
  );
};

export default HeroBanner;
